import React, { useCallback, useState } from 'react'
import _ from 'lodash'
import { Button } from 'antd'
import { Select } from 'antd-v5'
export default function SelectWithActionButton(props) {
    const [open, setOpen] = useState(props.defaultOpen);
    const { children, btnType, btnText = "", onActionClick , ...restProps } = props;
    const onButtonClick = useCallback((e) => {
        setOpen(false);
        (onActionClick || _.noop)(e);
    }, [onActionClick])
    return (
        <Select
            {...restProps}
            open={open}
            allowClear={_.has(props, 'allowClear') ? props.allowClear : !_.isNull(props.value)}
            onDropdownVisibleChange={setOpen}
            dropdownRender={menu => (
                <>
                {
                    !_.isEmpty(btnText)
                    ?
                    <div className="p-xs">
                        <Button size="small" disabled={props.disablebtn} name={props.name} block type={btnType} onClick={onButtonClick}>{btnText}</Button>
                    </div>
                    :
                    null
                }
                    {menu}
                </>
            )}
        >
            {
                children
            }
        </Select>
    )
}
